import { GOOGLE_PAY_SHARED_PAYLOAD } from '../constants/googlePay';

export const canMakePaymentsWithGooglePay = (isProd: boolean) => {
    const environment = isProd ? 'PRODUCTION' : 'TEST';

    return new google.payments.api.PaymentsClient({
        environment,
    }).isReadyToPay(GOOGLE_PAY_SHARED_PAYLOAD);
};
